/* @flow */
// eslint-disable-next-line import/no-commonjs
module.exports = require('./dist/post-robot'); // eslint-disable-next-line import/no-commonjs

module.exports["default"] = module.exports;